module.exports = __webpack_public_path__ + "static/MacBookPro-2-0ad1289b19f1c25f48419eb942181329.png";